import * as React from 'react';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { Box, Button, Card, CardActions, CardContent, CardMedia, Grid } from '@mui/material';
import Cp from '../Certifications/cp.png';
import Reh from '../Certifications/redh.png';
import Oracle from '../Certifications/oracle.png';

export default function Certify() {
  return (
    <Box id='cer' py={7} className="no-select" sx={{ pt: 20, pl: 6}}>
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.0 }}
      >
        <Typography variant="h3" align="center" sx={{ color: 'white', pb: 4 }} gutterBottom>
          Certificates
        </Typography>
      </motion.div>
      <Grid container spacing={4} justifyContent="center" sx={{pt:4}} >
        {[
          {
            title: 'AWS Cloud Practitioner',
            image: Cp, 
            link: 'https://www.credly.com/badges/508632d8-357e-480b-8bcc-b082534e91c1/public_url', 
          },
          {
            title: ' Red Hat EX-183',
            image: Reh, 
            link: 'https://www.credly.com/badges/ab74b0db-70a8-4e23-a194-38e75e26e63e/public_url', 
          },
          {
            title: 'Oracle Cloud Infrastructure',
            image: Oracle, 
            link: 'https://drive.google.com/file/d/1dCCj4eqb6saPrJRBpPJb6tk3L7fI9ugC/view?usp=sharing', 
          },
        ].map((certificate, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}
          sx={{
            '@media (min-width:50px) and (max-width:600px)':{
                  pr:3
                }
          }}
          >
            <Card
              sx={{
                maxWidth: 345,
                backgroundColor: 'black',
                color: 'white',
               boxShadow:'5px 5px 10px cyan',
                borderRadius: '10%',
                height: '450px',
                position: 'relative',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                flexDirection:'column',
                overflow: 'hidden',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            >
              <CardMedia
                sx={{ height: 200, objectFit:'contain',width:200}}
                image={certificate.image}
                title={certificate.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {certificate.title}
                </Typography>
              </CardContent>
              <CardActions
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: '50%',
                  opacity: 1,
                  transform: 'translateX(-50%)',
                  transition: 'opacity 0.3s ease-in-out',
                  zIndex: 1,
                  backgroundColor:'green',
                  '&:hover':{
                    borderRadius:'50%',
                    backgroundColor:'violet',
                    color:'red'
                  }
                }}
              >
                <Button size="small" href={certificate.link} target="_blank" style={{color:'white'}}>
                  Verify
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
